export default __webpack_public_path__ + "static/media/free_email_provider_domains.8565f7d4.txt";